module.exports = __webpack_public_path__ + "static/media/attendence.b405ec83.svg";